import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache the SEO overrides for the lifetime of the page load — the SEO component
// renders on every route, so we fetch /api/seo once and reuse the result.
let cache = null;
let inflight = null;

export function fetchSeoOverrides() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios
      .get(`${API}/seo`)
      .then((r) => {
        cache = r.data || { global: {}, pages: {} };
        return cache;
      })
      .catch(() => ({ global: {}, pages: {} }));
  }
  return inflight;
}

export function clearSeoOverridesCache() {
  cache = null;
  inflight = null;
}
